import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

export default function SidebarLayout(props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const syncSidebar = () => {
      setSidebarOpen(localStorage.getItem("sidebarOpen") === "true");
    };

    localStorage.setItem("sidebarOpen", "false");

    window.addEventListener("storage", syncSidebar);
    return () => window.removeEventListener("storage", syncSidebar);
  }, []);

  return (
    <>
      <div className={`main_container ${sidebarOpen ? "sidebar-open" : ""}`}>
        <div className="limani_body">
          <Sidebar />
          {props.children}
        </div>
      </div>
    </>
  );
}
